import React, { useEffect } from 'react'
import Header from '../../components/Header'
import { Footer } from '../../components/SharedLayout'

const IowaHomeownersLuxury: React.FC = () => {
  useEffect(() => {
    document.title = 'Full Maintenance Membership & Home Maintenance for Iowa Homeowners | Hudson My Home'
  }, [])

  const heading = 'rgb(15,15,15)'
  const sub = 'rgb(76,76,75)'

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-24 sm:pt-28 pb-16">
        {/* Hero banner */}
        <section className="mx-auto max-w-[1200px] px-4 sm:px-6 lg:px-8">
          <div className="relative h-[260px] sm:h-[360px] lg:h-[440px] rounded-2xl overflow-hidden">
            <img
              src="https://images.unsplash.com/photo-1502005229762-cf1b2da7c52f?auto=format&fit=crop&w=2000&q=80"
              alt="Elegant Iowa home exterior with evening light"
              className="absolute inset-0 h-full w-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(0,0,0,0.25) 0%, rgba(0,0,0,0.55) 100%)' }} />
            <div className="relative h-full flex flex-col justify-end p-6 sm:p-10">
              <p className="text-[11px] uppercase tracking-[0.18em] text-white/90">Blog</p>
              <h1 className="mt-1 text-2xl sm:text-4xl font-semibold text-white">Iowa Homeowners Are Choosing Luxury</h1>
              <p className="mt-2 text-sm sm:text-base max-w-3xl text-white/90">
                Discover how Iowa homeowners are protecting their investments and reclaiming their time with proactive luxury home maintenance. Experience effortless living in the Midwest.
              </p>
            </div>
          </div>
        </section>

        <article className="mx-auto max-w-[900px] px-4 sm:px-6 lg:px-8 mt-10">
          {/* Featured image inside article */}
          <figure className="mb-8">
            <img
              src="https://images.unsplash.com/photo-1479839672679-a46483c0e7c8?auto=format&fit=crop&w=1800&q=80"
              alt="Comfortable luxury interior maintained to perfection"
              className="w-full h-[240px] sm:h-[360px] object-cover rounded-xl"
              loading="lazy"
            />
            <figcaption className="mt-3 text-xs text-center" style={{ color: sub }}>
              Luxury means never worrying—because experts have already handled every detail.
            </figcaption>
          </figure>

          <section className="prose prose-lg max-w-none prose-p:my-5 prose-p:leading-relaxed prose-h2:mt-10 prose-h2:mb-3 prose-h3:mt-8 prose-h3:mb-2">
            <h2>Your Home Should Work for You, Not Against You</h2>
            <p>
              In Iowa's demanding climate, your home faces unique challenges every season. Brutal winters that freeze pipes. Humid summers that strain HVAC systems. Spring storms that test every seal and shingle. Fall preparations that seem endless.
            </p>
            <p>
              At Hudson My Home, we believe homeowners deserve to enjoy their homes without the constant worry of what might go wrong next. Your home should be your sanctuary, not your second job.
            </p>

            <h3>1. Iowa's Climate Demands Expert Care</h3>
            <p>
              The Midwest doesn't forgive amateur maintenance. Temperature swings from -20°F to 95°F put incredible stress on your home's systems. What starts as a small issue in September becomes an emergency repair in January.
            </p>
            <p>
              We understand Iowa's unique challenges because we live them too. Our specialists know exactly when to winterize your systems, how to protect against humidity damage, and which maintenance tasks can't wait until spring. We catch the problems before Iowa's weather makes them expensive.
            </p>

            <h3>2. Your Time Is Worth More Than DIY Projects</h3>
            <p>
              Successful professionals in Des Moines, Cedar Rapids, and Iowa City didn't build their careers by spending weekends researching contractors or learning HVAC repair on YouTube. Yet that's exactly what traditional homeownership demands.
            </p>
            <p>
              We eliminate the research, the phone calls, the scheduling conflicts, and the guesswork. One call handles everything. Your weekends become yours again. Your evenings stay peaceful. Your home maintenance happens seamlessly, without your involvement.
            </p>

            <h3>3. Preventive Care Protects Your Investment</h3>
            <p>
              Iowa's luxury real estate market is thriving, but only well-maintained homes capture premium values. Deferred maintenance doesn't just cost money, it destroys equity.
            </p>
            <p>
              Our comprehensive care plans protect your investment through every season. We maintain detailed records that enhance resale value. We prevent small issues from becoming major expenses. We ensure your home appreciates while your stress disappears.
            </p>

            <h3>4. The Mental Load of Homeownership Ends Here</h3>
            <p>
              Between work demands and family commitments, the last thing you need is wondering whether your furnace will survive another Iowa winter or if your basement will flood during spring thaw.
            </p>
            <p>
              We remove that mental burden entirely. Our monitoring systems watch your home 24/7. Our seasonal preparations happen automatically. Our emergency response ensures you're never left dealing with urgent repairs alone.
            </p>

            <h2>Live Like a Guest in Your Own Home</h2>
            <p>
              This is what luxury really means: coming home to a perfectly maintained sanctuary where everything works flawlessly because experts have already handled every detail.
            </p>
            <p>
              No more weekend projects. No more emergency repairs. No more stress about what might go wrong.
            </p>
            <p>
              Just the peace of mind that comes from knowing your home is cared for by professionals who understand both Iowa's challenges and your lifestyle expectations.
            </p>
            <p><strong>Ready to experience effortless homeownership? Your sanctuary awaits.</strong></p>
          </section>
        </article>
      </main>
      <Footer />
    </div>
  )
}

export default IowaHomeownersLuxury 